import React from 'react'
import { Button, Icon, notification, Popover } from 'antd'
import Parse from 'parse'
import {
  CONSOLIDATED_ORDER_ANALITIC_PDF_MODULE,
  CONSOLIDATED_ORDER_PDF_MODULE,
  findLatestPdfSnapshotId,
  openPdfFromSnapshot,
} from './pdf-snapshot-client'

const generatePdfWithCloudFunction = async ({
  cloudFunctionName,
  id,
  loadingKey,
  loadingMessage,
  successMessage,
}) => {
  notification.open({
    message: loadingMessage,
    description: 'O pdf está sendo criado/atualizado, aguarde...',
    key: loadingKey,
    duration: 0,
    placement: 'topLeft',
    icon: <Icon type="loading" />,
  })

  try {
    const response = await Parse.Cloud.run(cloudFunctionName, { id })
    await openPdfFromSnapshot(response.snapshotId)
    notification.close(loadingKey)
    notification.success({
      message: successMessage,
      description: 'O pdf foi aberto em uma nova aba.',
      placement: 'topLeft',
    })
    return response
  } catch (error) {
    notification.close(loadingKey)
    notification.error({
      message: 'Erro ao gerar/atualizar o pdf.',
      description: 'Alguma coisa deu errado, tente novamente.',
      duration: 5,
      placement: 'topLeft',
    })
    throw error
  }
}

export const generateConsolidatedOrderPdf = async (id) =>
  generatePdfWithCloudFunction({
    cloudFunctionName: 'generateConsolidatedOrder',
    id,
    loadingKey: 'generatingConsolidatedOrder',
    loadingMessage: 'Gerando/Atualizando o pdf do pedido consolidado',
    successMessage: 'Pedido consolidado gerado/atualizado com sucesso.',
  })

export const generateConsolidatedOrderAnaliticPdf = async (id) =>
  generatePdfWithCloudFunction({
    cloudFunctionName: 'generateConsolidatedOrderAnalitic',
    id,
    loadingKey: 'generatingConsolidatedOrderAnalitic',
    loadingMessage: 'Gerando/Atualizando o pdf analítico do pedido consolidado',
    successMessage: 'PDF analítico gerado/atualizado com sucesso.',
  })

const openOrGeneratePdf = async ({
  module,
  id,
  generatePdf,
  errorMessage,
}) => {
  try {
    const snapshotId = await findLatestPdfSnapshotId(module, id)
    if (snapshotId) {
      await openPdfFromSnapshot(snapshotId)
      return
    }
  } catch (error) {
    notification.error({
      message: errorMessage,
      description: 'Alguma coisa deu errado, tente novamente.',
      duration: 5,
      placement: 'topLeft',
    })
    return
  }
  try {
    await generatePdf(id)
  } catch (error) {
    // notificação já tratada em generatePdf
  }
}

export const renderOpenPdfButton = (row) => (
  <Popover content="Ver ou gerar pedido consolidado">
    <Button
      type="primary"
      icon="file-pdf"
      onClick={() => openOrGeneratePdf({
        module: CONSOLIDATED_ORDER_PDF_MODULE,
        id: row.objectId,
        generatePdf: generateConsolidatedOrderPdf,
        errorMessage: 'Erro ao abrir/gerar o pdf.',
      })}
    />
  </Popover>
)

export const renderOpenAnaliticPdfButton = (row) => (
  <Popover content="Ver ou gerar PDF analítico">
    <Button
      type="primary"
      icon="file-pdf"
      onClick={() => openOrGeneratePdf({
        module: CONSOLIDATED_ORDER_ANALITIC_PDF_MODULE,
        id: row.objectId,
        generatePdf: generateConsolidatedOrderAnaliticPdf,
        errorMessage: 'Erro ao abrir/gerar o pdf analítico.',
      })}
    />
  </Popover>
)
